module.exports = __webpack_public_path__ + "static/media/field.ebbd3964.jpg";